import i18next, { t } from "i18next";
import React from "react";
import { Trans } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import phBadge from "../../../assets/images/blurred2/payment/badge.webp";
import phFeMale from "../../../assets/images/blurred2/payment/female.webp";
import phMale from "../../../assets/images/blurred2/payment/male.webp";
import ImageLoader from "../../../components/ImageLoader";
import {
  faq,
  features,
  features2,
  paymentTypes,
  priceList,
  reviews,
} from "../../../utils/data";
import { addS3Url, checkGender } from "../../../utils/modules";

const images = {
  male: {
    src: addS3Url("/payment/male.jpg"),
    placeHolderImage: phMale,
  },
  female: {
    src: addS3Url("/payment/female.jpg"),
    placeHolderImage: phFeMale,
  },
};

const GatewayFeatures = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const gender = checkGender(location?.state?.gender) || "female";

  return (
    <>
      <p
        className="m-0 p-0 mt-5"
        style={{ fontSize: "17px", fontWeight: "bold" }}
      >
        <Trans
          i18nKey={"payment.guaranteed_checkout"}
          components={{ tag: <span style={{ color: "#2680EB" }} /> }}
        />
      </p>
      <div className="d-flex flex-row justify-content-center align-items-center mt-3">
        {paymentTypes.map((data) => (
          <img key={data?.id} className="mx-2" alt="" src={data?.src} />
        ))}
      </div>
      <div className="mt-5">
        <h3 className="mb-4" style={{ fontWeight: "bold" }}>
          {t("payment.what_you_get")}
        </h3>
        {features.map((data) => (
          <div key={data.id} className="d-flex flex-direction-row mt-2">
            <img
              className="my-1 me-2"
              alt=""
              src={addS3Url("/payment/green-tick.svg")}
              style={{ width: "15px", height: "14px" }}
            />
            <p
              className="m-0 p-0"
              style={{ fontWeight: "600", textAlign: "left" }}
            >
              {data?.title}
            </p>
          </div>
        ))}
      </div>
      <div className="mt-5">
        <h3 style={{ fontWeight: "bold" }}>{t("payment.users_love")}</h3>
        {reviews.map((data) => (
          <div key={data.id} className="d-flex flex-column mt-4">
            <div className="d-flex flex-row justify-content-between w-100">
              <div className="d-flex flex-row align-items-center">
                <img
                  className="my-1 me-2"
                  alt=""
                  src={data?.img}
                  style={{ width: "30px", height: "30px" }}
                />
                <p className="m-0 p-0 text-14" style={{ fontWeight: "600" }}>
                  {data?.name}
                </p>
              </div>
              <img alt="" src={addS3Url("/payment/instagram.svg")} />
            </div>
            <div
              className="mt-1"
              style={{ border: "1px solid #D6D6D6", borderRadius: "5px" }}
            >
              <p
                className="m-0 px-3 py-2"
                style={{ textAlign: "left", fontSize: "15px" }}
              >
                {data?.title}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div
        className="d-flex flex-column w-100 mt-4 px-2 py-2 mb-3"
        style={{ backgroundColor: "#E4E5EA", borderRadius: "5px" }}
      >
        <div className="d-flex flex-row justify-content-between align-items-center">
          <ImageLoader
            alt=""
            style={{ height: "180px", width: "auto" }}
            {...images[gender]}
          />
          <div className="w-50 d-flex flex-column">
            {priceList.map((data) => (
              <div
                key={data?.id}
                style={{ width: i18next.language === "en" ? "85%" : "92%" }}
                className={`px-2 py-1 mb-2 income-list-container ${
                  data.id === 2 && "income-list-container-end"
                }`}
              >
                <div className="d-flex flex-row fw-bold">
                  <img alt="" src={data?.icon} className="" />
                  <p
                    className="m-0 p-0 ms-1 price-list-text"
                    style={{ fontSize: "12px", color: data?.color }}
                  >
                    {data?.title}
                  </p>
                </div>
                <div className="d-flex flex-row">
                  <img
                    alt=""
                    src={addS3Url("/payment/dollar.png")}
                    style={{ height: "16px", width: "auto" }}
                    className=""
                  />
                  <p
                    className="m-0 p-0 ms-1"
                    style={{ fontSize: "10px", fontWeight: "600" }}
                  >
                    {data?.income}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div
          className={`d-flex flex-column ${
            i18next.language === "en" ? "align-items-center" : ""
          }`}
        >
          {features2.map((data) => (
            <div key={data.id} className="d-flex flex-direction-row">
              <img
                className="my-1 me-2"
                alt=""
                src={addS3Url("/payment/ok-hand.png")}
                style={{ width: "20px", height: "20px" }}
              />
              <p
                className="m-0 p-0"
                style={{ fontWeight: "600", textAlign: "left" }}
              >
                {data?.title}
              </p>
            </div>
          ))}
        </div>
      </div>
      <div className="mt-4 mb-3">
        <h3 className="mb-4" style={{ fontWeight: "bold" }}>
          {t("payment.people_often_ask")}
        </h3>
        {faq.map((data) => (
          <div
            key={data.id}
            className="d-flex flex-row mt-3 justify-content-start align-items-start"
          >
            <img
              className="my-1 me-2"
              alt=""
              src={addS3Url("/payment/q-mark.svg")}
            />
            <div className="d-flex flex-column">
              <p
                className="m-0 p-0 text-start fw-bold"
                style={{ fontSize: 18 }}
              >
                {data?.que}
              </p>
              <p className="m-0 p-0 text-start mt-1">{data?.ans}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 mb-3 px-1">
        <ImageLoader
          alt=""
          src={addS3Url("/payment/badge.jpg")}
          placeHolderImage={phBadge}
          style={{ height: "114px", width: "120px" }}
        />
        <h3 style={{ fontWeight: "bold" }}>
          {t("payment.money_back_guarantee")}
        </h3>
        <p
          className="mt-2 text-14
        "
          style={{ color: "#6C6E79" }}
        >
          <Trans
            i18nKey={"payment.guarantee_message"}
            components={{
              tag: (
                <span
                  style={{ textDecoration: "underline" }}
                  onClick={() => {
                    window.scrollTo(0, 0);
                    navigate("/terms");
                  }}
                />
              ),
            }}
          />
        </p>
      </div>
    </>
  );
};

export default GatewayFeatures;
